import { withRouter, Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  Badge,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { changeSportStatus } from "helpers/repository"
import MarketDetailsModal from "./MarketDetailsModal"
import { capitalizeFirstLetter, showErrorMessages } from "helpers/helpers"

const NOT_IN_FEED_TOOLTIP =
  "The active sportsbook feed does not carry this sport. It will not show on the site even when switched on."

// Missing `carried` field (older backend) is treated as carried === true.
const isCarried = row => row?.carried !== false

function Table(props) {
  const [isOpen, setIsOpen] = useState(false)
  const [detailsModal, setdetailsModal] = useState(false)
  const [sportList, setSportList] = useState([])
  const toggleViewModal = () => setdetailsModal(!detailsModal)

  const setSportsStatus = id => {
    changeSportStatus(id, successSetSport, errorSetSport)
  }

  const handleViewDetailsClick = (sport, sportId) => {
    setSportList({
      id: sport.id,
      name: sport.name,
      // name: capitalizeFirstLetter(sport.name.replace(/-/g, " ")),
      markets: sport.many_markets,
      sportId: sportId,
    })
    setdetailsModal(!detailsModal)
  }

  const successSetSport = res => {
    props.getSports()
  }

  const errorSetSport = err => {
    showErrorMessages(err)
  }

  const { data, marketData } = props
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          {row.name}
          {!isCarried(row) && (
            <>
              <Badge
                id={`not-in-feed-${row.id}`}
                className="ms-2 font-size-11 badge-soft-warning"
                pill
              >
                Not in feed
              </Badge>
              <UncontrolledTooltip
                placement="top"
                target={`not-in-feed-${row.id}`}
              >
                {NOT_IN_FEED_TOOLTIP}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Markets",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Button
          type="button"
          color="primary"
          className="btn-sm btn-rounded"
          onClick={() => {
            handleViewDetailsClick(row, row.id)
          }}
        >
          View Details
        </Button>
      ),
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Action",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        const blockActivate = row.status == 0 && !isCarried(row)
        return (
          <>
            <Row>
              <Col lg={5}>
                <span id={`activate-wrap-${row.id}`}>
                  <Button
                    onClick={() => {
                      setSportsStatus(row.id)
                    }}
                    type="button"
                    color="primary"
                    className="btn-sm"
                    disabled={blockActivate}
                  >
                    {row.status == 0 ? "Activate" : "Deactivate"}
                  </Button>
                </span>
                {blockActivate && (
                  <UncontrolledTooltip
                    placement="top"
                    target={`activate-wrap-${row.id}`}
                  >
                    {NOT_IN_FEED_TOOLTIP}
                  </UncontrolledTooltip>
                )}
              </Col>
            </Row>
          </>
        )
      },
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const { SearchBar } = Search

  const pageOptions = {
    sizePerPage: 20,
    totalSize: props.count,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setIsOpen(true)
    },
  }
  return (
    <>
      <Card>
        <CardBody>
          <MarketDetailsModal
            sportList={sportList}
            isOpen={detailsModal}
            toggle={toggleViewModal}
            setSportList={setSportList}
            setdetailsModal={setdetailsModal}
            detailsModal={detailsModal}
            markets={props.marketData}
            setIsOpen={setIsOpen}
            getSports={() => {
              props.getSports()
            }}
          />
          <div className="mb-4 h4 card-title">{"Sports"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                            rowEvents={rowEvents}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
